import { ErrorMessage } from "../constants";

export const mapErrorToField = (error) => {
  const errorFields = {}; // Renamed fieldError to errorFields
  const errorDetails = error?.data || []; // Renamed errorData to errorDetails

  // Check if the error has a valid message and that it exists in ErrorMessage
  if (error?.message && ErrorMessage.hasOwnProperty(error.message) && errorDetails.length) {
    errorDetails.forEach((errorItem) => {
      let [field, errorMessage] = errorItem.includes(":")
        ? errorItem.split(":").map(s => s.trim()) 
        : ["general", errorItem]; // Renamed key to field, value to errorMessage for clarity
      errorFields[field] = errorMessage;
    });
  }

  // Return an object with the error fields or a general error message
  return Object.keys(errorFields).length === 0
    ? { general: typeof error === "string" ? error : JSON.stringify(error) }
    : errorFields;
};
